export default __webpack_public_path__ + "efbc0ec736fb20448a5264d88e338eda.png";